import React, { useState } from 'react';
import styled from 'styled-components';
import { FiMenu, FiX } from 'react-icons/fi';

// Styled Components for the Header
const HeaderContainer = styled.header`
  background-color: #ffff;
  color: red;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

const Logo = styled.a`
  margin-left: 20px;

  img {
    width: 40px;
  }
`;

const NavList = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    position: fixed;
    top: 0;
    right: ${({ open }) => (open ? '0' : '-100%')};
    width: 200px;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    padding-top: 80px;
    align-items: center;
    transition: right 0.3s ease-in-out;
  }
`;

const NavItem = styled.li`
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 20px 0;
  }
`;

const NavLink = styled.a`
  color: red;
  text-decoration: none;
  font-weight: bold;
  transition: text-shadow 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.8),
                 0 0 20px rgba(255, 255, 255, 0.6),
                 0 0 30px rgba(255, 255, 255, 0.4);
  }
`;

const MenuIcon = styled.div`
  font-size: 30px;
  cursor: pointer;
  color: red;
  z-index: 1100;
  display: none;
  position: absolute;
  top: 20px;
  right: 20px;

  @media (max-width: 768px) {
    display: block;
  }
`;

// Header Component
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <HeaderContainer>
      <Logo href="#home"><img src="./logo.png" alt="logo" /></Logo>
      <MenuIcon onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FiX /> : <FiMenu />}
      </MenuIcon>
      <nav>
        <NavList open={menuOpen}>
          <NavItem>
            <NavLink href="#home">Home</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#about">About</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#ministries">Ministries</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#events">Events</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#sermons">Sermons</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#donate">Donate</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#contact">Contact</NavLink>
          </NavItem>
        </NavList>
      </nav>
    </HeaderContainer>
  );
};

export default Header;
